import React from "react";
import { trpc } from "../../main/components/trpc.ts";

const OrgManagerContainer = () => {
  const allOrgs = trpc.user.getAllOrgs.useQuery().data;
  const [isCreatingOrg, setIsCreatingOrg] = React.useState(false);
  const [newOrgName, setNewOrgName] = React.useState("");
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const utils = trpc.useUtils();
  const createOrgMutation = trpc.user.createOrganization.useMutation({
    onMutate: () => {
      setIsSubmitting(true);
    },
    onSuccess: () => {
      setIsSubmitting(false);
      setNewOrgName("");
      utils.user.invalidate();
    },
  });

  const handleSubmit = () => {
    createOrgMutation.mutate({ name: newOrgName });
  };

  const isValid = newOrgName.length > 2;

  return (
    <div>
      <h1>Manage organizations</h1>
      <ul>
        {allOrgs?.map((org) => (
          <li key={org.id}>{org.name}</li>
        ))}
      </ul>
      <div>
        <button onClick={() => setIsCreatingOrg(true)}>
          Create organization
        </button>
        {isCreatingOrg && (
          <div>
            <input
              type="text"
              value={newOrgName}
              onChange={(e) => setNewOrgName(e.target.value)}
            />
            <button disabled={!isValid || isSubmitting} onClick={handleSubmit}>
              Créer
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default OrgManagerContainer;
